namespace $.$$ {
	export class $shm_hitalama_guide extends $.$shm_hitalama_guide {
		catalog() { return this.$.$shm_hitalama_guide_catalog.current()! }
		editable() { return this.catalog()?.can_change() ?? false }
		guide_pages() { return [ this.List(), ...( this.repository_opened() ? [ this.Repository() ] : [] ), this.Panel() ] }
		@ $mol_mem
		hierarchy() {
			const tree = new Map( this.catalog()?.tree() ?? [['',[]]] ), needle = this.query().trim().toLowerCase()
			if( !needle ) return tree
			const keep = ( id: string ): boolean => {
				const title = this.catalog()?.group( id )?.title() ?? this.page_title( id )
				if( ( id + ' ' + title ).toLowerCase().includes( needle ) ) return true
				const children = ( tree.get( id ) ?? [] ).filter( keep ); tree.set( id, children ); return children.length > 0
			}
			tree.set( '', ( tree.get('') ?? [] ).filter(keep) ); return tree
		}
		roots() { return this.hierarchy().get('') ?? [] }
		children( id: string ) { return this.hierarchy().get(id) ?? [] }
		@ $mol_mem_key
		expanded( id: string, next?: boolean ) { return this.$.$mol_state_local.value<boolean>('guide:'+this.catalog()?.link().str+':expanded:'+id,next)??true }
		drag_locked() { return !!this.query().trim() }
		identity( id: string ) { return id }
		page_current( id: string ) { return this.Panel().selected() === id }
		folder_options() { return this.catalog()?.folder_options() ?? { '': 'Без группы' } }
		@ $mol_action
		group_toggle( id: string, event?: Event ) { if( event ) this.Names().expanded(id,!this.Names().expanded(id)); return null }
		page_title( id: string ) { return this.catalog()!.page( id )!.read().title }
		create_content() { return this.create_opened() ? [ this.Create() ] : [] }
		@ $mol_action
		add_toggle( event?: Event ) { if( event ) this.create_opened( !this.create_opened() ); return null }
		private creations = new WeakMap<Event, { id: string, title: string, kind: string, parent: string }>()
		create_request( event: Event ) { const previous = this.creations.get( event ); if( previous ) return previous; const id = this.new_id().trim(); this.$.$shm_hitalama_guide_catalog.slug( id ); const request = { id, title: this.new_title().trim() || id, kind: this.new_kind(), parent: this.new_parent() }; this.creations.set( event, request ); return request }
		@ $mol_action
		add( event?: Event ) {
			if( !event ) return null
			const request = $mol_wire_sync( this ).create_request( event ), {id,title,parent} = request
			if( request.kind === 'group' ) { $mol_wire_sync( this.catalog() ).group_create( event, id, title, parent ) }
			else {
				$mol_wire_sync( this.catalog() ).create( event, id, JSON.stringify({ title, body: '# ' + title + '\n\n', links: [], parent }) )
				this.$.$mol_state_arg.value( 'guide_page', id ); this.Panel().editing( true )
			}
			this.create_opened(false)
			return null
		}
		@ $mol_mem
		sections_text( next?: string ) {
			return next ?? ( this.catalog()?.Sections()?.keys() ?? [] ).map( String ).sort().map( key => key + ' | ' + this.catalog()!.Sections()!.key( key )!.val() ).join( '\n' )
		}
		@ $mol_action
		save_sections( event?: Event ) {
			if( !event ) return null
			if( !this.editable() ) throw new Error( 'Нет прав на изменение руководства.' )
			const pairs = this.sections_text().split( '\n' ).filter( line => line.trim() ).map( line => line.split( '|' ).map( text => text.trim() ) )
			for( const [ key, id ] of pairs ) { if( !/^[a-z0-9_]+$/.test( key ) || !this.catalog().page( id ) ) throw new Error( 'Укажите раздел и существующий ID страницы.' ) }
			const sections = this.catalog().Sections( null )!
			for( const key of sections.keys() ) if( !pairs.some( pair => pair[0] === key ) ) sections.key( key, null )!.val( '' )
			for( const [ key, id ] of pairs ) sections.key( key, null )!.val( id )
			return null
		}
	}
}
